import { render } from "./TagAddHeader.vue?vue&type=template&id=69538aca"
import script from "./TagAddHeader.vue?vue&type=script&lang=js"
export * from "./TagAddHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__